module.exports = __webpack_public_path__ + "img/mood5.c1420cb7.png";